import { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { toggleSideBar } from '@greenkub-fronts/domain/ui';

import { useWindowDimensions } from '@greenkub-fronts/shared/utils';
import { AppDispatch } from '@greenkub-fronts/shared/interface';

import {
  Header,
  Menu,
  ProjectNavigationBar,
  Icon,
  IconEnum,
} from '@greenkub-fronts/shared/ui';
import {
  BorderOuterOutlined,
  FileProtectOutlined,
  HomeOutlined,
} from '@ant-design/icons';

export interface HomeLayoutProps {
  children: React.ReactElement;
  withProjectNavigationBar: boolean | undefined;
}

export function HomeLayout(props: HomeLayoutProps) {
  const { children, withProjectNavigationBar } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { windowWidth } = useWindowDimensions();
  const [superAdmin, setSuperAdmin] = useState(false);

  const toggleSuperAdmin = () => {
    setSuperAdmin(!superAdmin);
  };

  const handleClickLink = () => {
    if (windowWidth < 767) {
      dispatch(toggleSideBar(false));
    }
  };

  return (
    <Fragment>
      <Header isCrm={true} />

      <Menu>
        <>
          <Fragment>
            <li className="Menu-item">
              <Link to="/" onClick={handleClickLink}>
                <Icon name={IconEnum.FORMAT_LIST_BULLETED} />
                <span>Dashboard</span>
              </Link>
            </li>
            <li className="Menu-item">
              <Link to="/archives" onClick={handleClickLink}>
                <Icon name={IconEnum.DNS} />
                <span>Archives</span>
              </Link>
            </li>
          </Fragment>

          <li className="Menu-item">
            <a onClick={toggleSuperAdmin}>
              <Icon name={IconEnum.SUPERVISOR_ACCOUNT} />
              <span>Admin</span>
            </a>
          </li>

          {superAdmin && (
            <Fragment>
              <li>
                <Link to="/admin/models" onClick={handleClickLink}>
                  <HomeOutlined />
                  <span>Models</span>
                </Link>
              </li>
              <li>
                <Link to="/admin/finishEquipment" onClick={handleClickLink}>
                  <BorderOuterOutlined />
                  <span>Finition & Equipement</span>
                </Link>
              </li>
              <li>
                <Link to="/admin/ribs" onClick={handleClickLink}>
                  <FileProtectOutlined />
                  <span>Ribs</span>
                </Link>
              </li>
            </Fragment>
          )}
        </>
      </Menu>

      <main className={'Home-container'}>
        {withProjectNavigationBar && <ProjectNavigationBar />}
        {children}
      </main>
    </Fragment>
  );
}

export default HomeLayout;
